import { gql } from '@apollo/client';

import { customerAddressFragment } from './addresses';

export const UpdateAddressQuery = gql`
  ${customerAddressFragment}

  mutation UpdateAddress($id: ID!, $address: CustomerAddressInputData!) {
    user {
      id
      updateAddress(id: $id, address: $address) {
        ...customerAddress
      }
    }
  }
`;
